import React from "react";
import Text from "./Text";
import styled from "styled-components";
import DietitianAvatar from "./DietitianAvatar";

const ConsultationCard = ({ dietitianImage, card, movementValue }) => {
  return (
    <div className="card-wrapper rounded-md w-auto shadow-[0_10px_20px_0_rgb(210_210_210_/_25%)] mb-4">
      <div className="heading h-52 xs:text-xl md:text-[26px] text-white overflow-hidden rounded-t-md relative  font-medium xs:h-40 sm:h-32 md:h-52 w-full">
        <ConsultationBg
          className={`background absolute w-[250%] h-full top-0 -left-1/2 transition-all duration-500 bg-no-repeat sm:bg-cover md:bg-auto`}
          consultationImage={card.header.bg}
          movementValue={movementValue}
        />
        {card.header.title && (
          <Text classes={"absolute top-1/2 -translate-y-1/2 px-5 text-[26px]"}>
            {card.header.title}
          </Text>
        )}
      </div>
      <div className="content relative px-4">
        <div className="dietitian absolute bottom-[calc(100%_-_30px)]">
          <div className="flex">
            {Array(4)
              .fill(true)
              .map((avatar, index) => (
                <DietitianAvatar dietitianImage={dietitianImage} key={index} />
              ))}
          </div>
        </div>
        <div className="type pb-4 text-[#424242] uppercase font-normal text-[13px] pt-[60px]">
          <Text text={"Online Consultation"} classes="" />
        </div>
        <div className="price font-semibold text-lg text-[#ff7b1a]  relative -mt-[13px]">
          <Text
            text={"98 T.L"}
            classes="absolute bottom-full bg-[#ff7b1a]/20 rounded px-3 py-1 right-0"
          />
        </div>
        <div className="desc pb-5 mt-[13px] text-base font-semibold">
          <Text
            text={"30 text-base  min One to One Consultation Turkish - English"}
            classes=""
          />
        </div>
      </div>
    </div>
  );
};

const ConsultationBg = styled.div`
  background-image: url(${(props) => props.consultationImage});
  background-position: ${(props) => props.movementValue}% center;
`;

export default ConsultationCard;
